import React from "react";
import { LANDING } from "@/constants/testIds";
import { ArrowUpRight } from "lucide-react";
import BrandMark from "@/components/landing/BrandMark";

export default function Footer() {
  return (
    <footer
      data-testid={LANDING.footer}
      className="bg-primary text-primary-foreground"
    >
      <div className="px-6 md:px-12 lg:px-24 pt-24 md:pt-32 pb-12">
        {/* Big CTA */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-20 border-b border-white/15">
          <div className="lg:col-span-8">
            <p className="label-eyebrow text-accent mb-6">Let&apos;s talk</p>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl h-tight font-light">
              Your renewal is{" "}
              <span className="font-black italic text-accent">closer</span>{" "}
              than you think.
            </h2>
            <p className="mt-8 max-w-xl text-primary-foreground/75 text-base md:text-lg">
              90 days out is the right time to start. 30 days out is when
              brokers get to dictate terms. Reach out — we&apos;ll tell you which
              side of the line you&apos;re on.
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end items-end">
            <a
              href="#quote"
              className="inline-flex items-center gap-3 bg-accent text-accent-foreground px-7 py-4 rounded-md text-base font-semibold hover:opacity-90 transition-opacity"
            >
              Start my quote
              <ArrowUpRight size={18} />
            </a>
          </div>
        </div>

        {/* Link columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 py-16">
          <div>
            <p className="label-eyebrow text-primary-foreground/60 mb-5">
              Coverage
            </p>
            <ul className="space-y-3 text-sm">
              <li><a href="#services" className="hover:text-accent">Key Person Insurance</a></li>
              <li><a href="#services" className="hover:text-accent">Group life</a></li>
              <li><a href="#services" className="hover:text-accent">Workers&apos; comp</a></li>
              <li><a href="#services" className="hover:text-accent">Liability</a></li>
              <li><a href="#services" className="hover:text-accent">Property</a></li>
              <li><a href="#services" className="hover:text-accent">Cyber</a></li>
            </ul>
          </div>
          <div>
            <p className="label-eyebrow text-primary-foreground/60 mb-5">
              Firm
            </p>
            <ul className="space-y-3 text-sm">
              <li><a href="#testimonials" className="hover:text-accent">Clients</a></li>
              <li><a href="#process" className="hover:text-accent">How we work</a></li>
              <li><a href="#faq" className="hover:text-accent">FAQ</a></li>
              <li><a href="#contact" className="hover:text-accent">Contact</a></li>
            </ul>
          </div>
          <div>
            <p className="label-eyebrow text-primary-foreground/60 mb-5">
              Get in touch
            </p>
            <ul className="space-y-3 text-sm text-primary-foreground/85">
              <li>(929) 456-9852</li>
              <li className="break-all">JanayJones822@gmail.com</li>
              <li className="pt-2 text-primary-foreground/65 text-xs">
                Monday – Friday<br />8:00am – 6:00pm EST
              </li>
            </ul>
          </div>
          <div>
            <p className="label-eyebrow text-primary-foreground/60 mb-5">
              Licensing
            </p>
            <ul className="space-y-3 text-xs text-primary-foreground/65 leading-relaxed">
              <li>NAIC #38211</li>
              <li>Licensed in 38 states</li>
              <li>E&amp;O coverage maintained at $5M</li>
              <li className="pt-2">
                Insurance products are offered through Key Legacy Protection,
                LLC. Coverage subject to underwriting, terms and conditions.
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-10 border-t border-white/15">
          <div className="flex items-center gap-3">
            <BrandMark size={88} variant="full" />
          </div>
          <p className="text-xs text-primary-foreground/55">
            © {new Date().getFullYear()} Key Legacy Protection, LLC. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
